import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSingleNeutralActionsCheck1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "single-neutral-actions-check-1" }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M.75,17.25a6.753,6.753,0,0,1,9.4-6.208"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-1",
			cx: 7.5,
			cy: 4.875,
			r: 4.125
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-1",
			cx: 17.25,
			cy: 17.25,
			r: 6
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M19.924,15.505l-2.905,3.874a.751.751,0,0,1-1.131.08l-1.5-1.5"
		})
	]
});
export default SvgSingleNeutralActionsCheck1;
